import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

function getAllProjects() {
    return dispatch => {
        return apiCaller
            .call(api.getAllProjects())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'SIMULATIONENR__INIT_PROJECTS',
                        projects: data.projects
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setSimulationenrProjects - ', error);
                throw error;
            });
    };
}

function getProjectDetails(projectId) {
    return dispatch => {
        return apiCaller
            .call(api.getProjectDetails(projectId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'SIMULATIONENR__SET_PROJECTDETAILS',
                        project: data.projectDetails
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setSimulationenrCommercialAgentDetails - ', error);
                throw error;
            });
    };
}

export { getAllProjects, getProjectDetails };



// WEBPACK FOOTER //
// ./environments/simulationenr/data/Projects/actions.js